// Mock data for The Nick and JJ Show

export const episodes = [
  {
    id: 1,
    title: "Season 1 Premiere: Welcome to the Show!",
    thumbnail: "https://img.youtube.com/vi/o0YKkLOm__0/maxresdefault.jpg",
    videoId: "o0YKkLOm__0",
    description: "Nicholas and Janae kick off the show with games, laughs, and special guests!"
  },
  {
    id: 2,
    title: "Entrepreneurship for Teens",
    thumbnail: "https://img.youtube.com/vi/Q1sDjGQFiCY/maxresdefault.jpg",
    videoId: "Q1sDjGQFiCY",
    description: "Young entrepreneurs share their success stories and tips."
  },
  {
    id: 3,
    title: "Pop Culture Roundup",
    thumbnail: "https://img.youtube.com/vi/vODRei2-eQc/maxresdefault.jpg",
    videoId: "vODRei2-eQc",
    description: "The hosts discuss the latest trends in music, movies, and social media."
  },
  {
    id: 4,
    title: "Building Confidence & Self-Love",
    thumbnail: "https://img.youtube.com/vi/YGcte7Riyv0/maxresdefault.jpg",
    videoId: "YGcte7Riyv0",
    description: "Real talk about self-esteem, body positivity, and mental health."
  },
  {
    id: 5,
    title: "Special at Chick-fil-A Hall of Fame",
    thumbnail: "https://img.youtube.com/vi/cHu0HWcdaFc/maxresdefault.jpg",
    videoId: "cHu0HWcdaFc",
    description: "An exciting special episode filmed at the College Football Hall of Fame!"
  },
  {
    id: 6,
    title: "Teen Talent Showcase",
    thumbnail: "https://img.youtube.com/vi/zZOrrxaN7gY/maxresdefault.jpg",
    videoId: "zZOrrxaN7gY",
    description: "Talented teens perform and share their creative passions."
  }
];

export const teamMembers = [
  {
    id: 3,
    name: "Danielle Hubbard",
    role: "Executive Producer",
    instagram: "https://www.instagram.com/motherhubbardllc/",
    image: "/danielle.png"
  },
  {
    id: 4,
    name: "Toiya Tillman",
    role: "Producer",
    instagram: "https://www.instagram.com/toiyatillman/",
    image: "/toiya.png"
  },
  {
    id: 5,
    name: "Bisola Salimonu",
    role: "Creative Producer",
    instagram: "https://www.instagram.com/bisolaent/",
    image: "/bisola.png"
  },
  {
    id: 6,
    name: "Shayla Raquel",
    role: "Director",
    instagram: "https://www.instagram.com/shaylaracquel?igsh=c3R5YWV1emVoeXoy",
    image: "/shayla.png"
  },
  {
    id: 7,
    name: "Jackie Madison",
    role: "Communications Director",
    instagram: "https://www.instagram.com/getfitglamourgirlstyle?igsh=MWJ6dW0yZmU3aTc0Ng==",
    image: "/jackie.png"
  },
  {
    id: 8,
    name: "Tylisha McKinney",
    role: "Publicist",
    instagram: "https://www.instagram.com/tyelive?igsh=MTNoOXdxaGx5ODg5dg==",
    image: "/tylisha.png"
  }
];

export const sponsors = [
  {
    id: 1,
    name: "Dave & Buster's",
    logo: "/dave-busters-new.png",
    website: "https://www.daveandbusters.com"
  },
  {
    id: 2,
    name: "Hibbett Sports",
    logo: "/hibbett-new.svg",
    website: "https://www.hibbett.com"
  },
  {
    id: 3,
    name: "Manhattan Fashion",
    logo: "/manhattan-logo.png",
    website: "https://www.manhattan-fashion.com"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "The Nick and JJ Show isn't just a show — it's a movement. We're building a positive platform where kids feel seen, heard, and celebrated.",
    author: "Danielle Hubbard",
    role: "Executive Producer"
  },
  {
    id: 2,
    quote: "This show gave me the confidence to share my voice. Nick and JJ make everyone feel welcome and important.",
    author: "Sarah J.",
    role: "Teen Audience Member"
  },
  {
    id: 3,
    quote: "As a parent, I love that there's a positive, empowering show my kids can watch that celebrates their generation.",
    author: "Marcus T.",
    role: "Parent"
  }
];